import React from "react";
import Container from "../components/container";
import SEO from "../components/seo";
import TitleBanner from "../components/titleBanner";
import Card from "../components/imageCard";
import LinkNewTab from "../components/LinkNewTab";
import { graphql } from "gatsby";

class AssetsPage extends React.Component {
  render() {
    const title = "Unity Assets";

    return (
      <Container defKey="1">
        <SEO title={title} />
        <TitleBanner title={title}>
          Here are all my assets from the{" "}
          <LinkNewTab to="https://assetstore.unity.com/publishers/51178">
            Unity Asset Store
          </LinkNewTab>{" "}
          as well as my assets on{" "}
          <LinkNewTab to="https://github.com/CrizGames">GitHub</LinkNewTab>.
        </TitleBanner>
        <div className="cardsContainer">
          <Card
            id="vour"
            title="Vour"
            image={this.props.data.vour.childImageSharp.fluid}
            buttonText="View in the Asset Store"
            buttonLink="http://u3d.as/2kQ2"
          >
            Vour helps you making virtual tours with images & videos in 2D,
            360°, 3D, and 3D 360° and 3D scenes.
            <br />
            There is also Oculus VR support.
            <br />
            <LinkNewTab to="https://crizgames.github.io/VourDemo/">
              Try the web demo!
            </LinkNewTab>
          </Card>
          <Card
            id="cgai"
            title="CG-AI"
            image={this.props.data.cgai.childImageSharp.fluid}
            buttonText="View on GitHub"
            buttonLink="https://github.com/CrizGames/CG-AI"
          >
            My artificial intelligence library for Unity. It includes Neural
            Networks, Q-learning, and Deep Q-learning.
          </Card>
        </div>
      </Container>
    );
  }
}

export default AssetsPage;

export const query = graphql`
  query {
    vour: file(relativePath: { eq: "vour.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    cgai: file(relativePath: { eq: "cgai.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;
